import request from "@/utils/request";

export default {
  // QBR计划列表查询
  getQbrPlanLists: (param) => {
    return request({
      url: `/qbr/findListPage`,
      method: "post",
      data: param,
    });
  },
  getMonth: () => {
    return request({
      url: `/qbr/getMonth`,
      method: "get",
      data: {},
    });
  },
  getCategoryLists: (param) => {
    return request({
      url: `/category/findCategoryForQspi`,
      method: "post",
      data: param,
    });
  },
  saveQbrPlan: (param) => {
    return request({
      url: `/qbr/updateQbr`,
      method: "post",
      data: param,
    });
  },
  //QBR维护列表查询
  getQbrMaintainceLists: (param) => {
    return request({
      url: `/qbr/findList`,
      method: "post",
      data: param,
    });
  },
  // QBR维护详情查询
  getQbrMaintainceDetail: (param) => {
    return request({
      url: `/qbr/findList`,
      method: "post",
      data: param,
    });
  },
  // 获取文件列表
  getFileLists: (param) => {
    return request({
      url: `/file/fileList`,
      method: "post",
      data: param,
    });
  },
  // 保存qbr维护
  saveQbr: (param) => {
    return request({
      url: `/qbr/saveQbr`,
      method: "post",
      data: param,
    });
  },
  dqmpDownload: (param) => {
    return request({
      url: `/qbr/qbrDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  qbrPerformance: (param) => {
    return request({
      url: `/performance/query`,
      method: "post",
      data: param,
    });
  },
  performanceDownload: (param) => {
    return request({
      url: `/performance/download`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
